import "./App.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing/Landing";
import ProductEdit from "./pages/Landing/ProductEdit";
import { ToastContainer } from "react-toastify";
import ProductNew from "./pages/Landing/ProductNew";
import Orders from "./pages/Landing/Orders";
import OrderDetail from "./pages/Landing/OrderDetail";
import Banners from "./pages/Landing/Banners";
import Four0four from "./pages/404/404";
import Statistics from "./pages/Statistics/Statistics";
import Customers from "./pages/Customers/Customers";
import TopBar from "./components/TopBar";
import Login from "./pages/Login/Login";
import Sidebar from "./components/Sidebar";
import ProductDetail from "./pages/Products/ProductDetail";
import Products from "./pages/Products/Products";
import Branches from "./pages/Branches";
import System from "./pages/System";
import Auctions from "./pages/Auctions/Auctions";
import Bids from "./pages/Bids/Bids";
import BankAccounts from "./pages/BankAccounts/BankAccounts";
import UserManagement from "./pages/UserManagement/UserManagement";

const AppContent = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <div className="app-container">
      {!isLoginPage && <TopBar />}
      <div className="app-content">
        {/* Permanent sidebar for desktop */}
        {!isLoginPage && (
          <aside className="sidebar-container">
            <Sidebar />
          </aside>
        )}

        {/* Main content */}
        <main className={`main-container ${isLoginPage ? "w-full" : ""}`}>
          <ToastContainer />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Landing /></ProtectedRoute>} />
            <Route path="/product/:productId" element={<ProtectedRoute><ProductDetail /></ProtectedRoute>} />
            <Route path="/addnew" element={<ProtectedRoute><ProductNew /></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute><Products /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
            <Route path="/order/:order_id" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
            <Route path="/banners" element={<ProtectedRoute adminOnly><Banners /></ProtectedRoute>} />
            <Route path="/statistics" element={<ProtectedRoute><Statistics /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
            <Route path="/auctions" element={<ProtectedRoute><Auctions /></ProtectedRoute>} />
            <Route path="/bids" element={<ProtectedRoute><Bids /></ProtectedRoute>} />
            <Route path="/bank-accounts" element={<ProtectedRoute><BankAccounts /></ProtectedRoute>} />
            <Route path="/branches" element={<ProtectedRoute adminOnly><Branches /></ProtectedRoute>} />
            <Route path="/branches/:branchName" element={<ProtectedRoute adminOnly><Branches /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute adminOnly><UserManagement /></ProtectedRoute>} />
            <Route path="/system" element={<ProtectedRoute adminOnly><System /></ProtectedRoute>} />
            <Route path="*" element={<Four0four />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </Provider>
  );
}

export default App;
